var inputIsActive = function inputIsActive(element, coApplicantIsActive) {
  if (element.getIn(['selectedGroup', 'Name']) === 'CoApplicant') {
    return coApplicantIsActive.current;
  }

  return true;
};

export default inputIsActive;